import React from 'react';
import PropTypes from 'prop-types';
import { Card, Row, Col } from 'react-bootstrap';
import { map } from 'lodash';
import { ATLAS_TEMPLATES } from '../../atoms/AtlasAtoms/atlas-elements';

const AtlasImageCard = ({ image, onAtlasClick }) => {
  const tamano = () => {
    const screenSize = window.innerWidth / window.screen.availWidth;
    if (screenSize < 0.3) {
      return '8rem';
    }
    return '10rem';
  };

  return (
    <Row style={{ margin: '10px', justifyContent: 'start' }}>
      <Card
        style={{
          borderRadius: '20%',
          cursor: 'pointer',
          overflow: 'hidden',
          height: tamano(),
          width: tamano(),
          margin: 0
        }}
        onClick={onAtlasClick}
      >
        <Card.Img variant="top" src={image} />
      </Card>
    </Row>
  );
};

AtlasImageCard.propTypes = {
  image: PropTypes.string.isRequired,
  onAtlasClick: PropTypes.func.isRequired
};

const AtlasSelector = ({ handleAtlasType, isBasic }) => {
  return (
    <Col>
      <div>
        <h4>Dashboard</h4>
        <Row>
          {map(ATLAS_TEMPLATES.properties, ({ image, value, title, type }) => {
            if (value !== 'templateScorecardFocusedTrainAtlas') {
              if (type === 'Dashboard') {
                return (
                  <div title={title} key={value}>
                    <AtlasImageCard image={image} onAtlasClick={() => handleAtlasType(value)} />
                  </div>
                );
              }
            }
            return false;
          })}
        </Row>
      </div>
      {!isBasic && (
        <>
          <div>
            <h4>AI Atlas</h4>
            <Row>
              {map(ATLAS_TEMPLATES.properties, ({ image, value, title, type }) => {
                if (value !== 'templateScorecardFocusedTrainAtlas') {
                  if (type === 'AI Atlas') {
                    return (
                      <div title={title} key={value}>
                        <AtlasImageCard image={image} onAtlasClick={() => handleAtlasType(value)} />
                      </div>
                    );
                  }
                }
                return false;
              })}
            </Row>
          </div>
          <div>
            <h4>Others</h4>
            <Row>
              {map(ATLAS_TEMPLATES.properties, ({ image, value, title, type }) => {
                if (value !== 'templateScorecardFocusedTrainAtlas') {
                  if (type === 'Others') {
                    return (
                      <div title={title} key={value}>
                        <AtlasImageCard image={image} onAtlasClick={() => handleAtlasType(value)} />
                      </div>
                    );
                  }
                }
                return false;
              })}
            </Row>
          </div>
        </>
      )}
    </Col>
  );
};

AtlasSelector.propTypes = {
  handleAtlasType: PropTypes.func.isRequired,
  isBasic: PropTypes.bool.isRequired
};

export default AtlasSelector;
